<form [formGroup]="selectForm">
  <div class="app-form-loader">
    @if (searchable()) {
      <mat-form-field [appearance]="appearance()" subscriptSizing="dynamic">
        <mat-label i18n>Select or search forms</mat-label>
        <input matInput #formSearch #searchTrigger="matAutocompleteTrigger"
          [matAutocomplete]="formOptions"
          [value]="searchDisplayText()"
          (input)="onSearchInput(formSearch.value)"
          (focus)="formSearch.select()"
          [disabled]="formLoaded() && !loadOnSelectionChange()" />
        @if (searchDisplayText()) {
          <button matIconButton matSuffix type="button"
            aria-label="Clear form search" i18n-aria-label
            [disabled]="formLoaded() && !loadOnSelectionChange()"
            (click)="onSearchInput(''); formSearch.focus(); searchTrigger.openPanel()">
            <mat-icon>close</mat-icon>
          </button>
        }
        <button matIconButton matSuffix type="button"
          aria-label="Show forms" i18n-aria-label
          [disabled]="formLoaded() && !loadOnSelectionChange()"
          (click)="formSearch.focus(); searchTrigger.openPanel()">
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-autocomplete #formOptions="matAutocomplete"
          [displayWith]="displayTemplate"
          (optionSelected)="selectTemplate($event.option.value)">
          @for (templ of matchingTemplates(); track templ.uuid) {
            <mat-option [value]="templ">{{ templ.title }}</mat-option>
          } @empty {
            <mat-option disabled i18n>No matching forms</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    } @else {
      <mat-form-field
        [appearance]="appearance()"
        subscriptSizing="dynamic"
        class="custom-select-panel"
      >
        <mat-select
          formControlName="selectedForm"
          i18n-placeholder
          placeholder="Select form"
          (selectionChange)="formSelectionChange($event.value)"
        >
          @for (templ of loadedTemplates(); track templ.uuid) {
            <mat-option [value]="templ.uuid" class="custom-select-panel">
              {{ templ.title }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (!loadOnSelectionChange()) {
      <button
        matButton="filled"
        color="accent"
        (click)="loadForm()"
        [disabled]="!selectForm.valid || formLoaded()"
        i18n
      >
        Load Form
      </button>
      <button
        matButton="elevated"
        type="button"
        (click)="clearRefresh()"
        class="app-panel-button-old"
        i18n
      >
        Clear and Refresh
      </button>
    }
  </div>
</form>
